import React from 'react';
import { Form } from 'antd';
import { useIntl } from 'react-intl';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';

import { removeMaskFromEvent } from '@/utils/mask/removeMask';
import { cnpjMask } from '@/utils/mask/commonMasks';
import { maskFieldValidator } from '@/utils/mask';

import FloatingFormItem from '../FloatingFormItem';
import { NamePath } from 'antd/lib/form/interface';
import { Rule } from 'antd/lib/form';
import { validateCnpj } from '@/utils/functions/validateCnpj';

interface CnpjFormFieldProps extends Omit<MaskedInputProps, 'mask'> {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;

  label?: string;
  fieldName?: NamePath;
  requiredRuleTextId?: string;
  lengthRuleTextId?: string;
  initialValue?: string;

  required?: boolean;
  floating?: boolean;
  disabled?: boolean;
  notRequired?: boolean;
}

const CnpjFormField: React.FC<CnpjFormFieldProps> = ({
  fieldName = 'cnpj',
  label = 'CNPJ',
  requiredRuleTextId = 'commons.form.errors.requiredCnpj',
  lengthRuleTextId = 'commons.form.errors.invalidCnpj',
  required = true,
  floating = true,
  initialValue,
  onChange,
  disabled,
  notRequired,
}) => {
  const intl = useIntl();

  const rules: Rule[] = [
    {
      min: 14,
      max: 14,
      validator: async (rule, value) => {
        if (value) {
          return Promise.all([
            maskFieldValidator(rule, value, 'CNPJ'),
            value.length === rule.max
              ? validateCnpj(value)
                ? Promise.resolve()
                : Promise.reject(new Error('CNPJ inválido'))
              : Promise.resolve(),
          ]);
        }
      },
      message: intl.formatMessage({ id: lengthRuleTextId }),
    },
  ];

  if (required) {
    rules.push({
      required: true,
      message: intl.formatMessage({ id: requiredRuleTextId }),
    });
  }

  return floating ? (
    <FloatingFormItem
      label={label}
      name={fieldName}
      initialValue={initialValue}
      getValueFromEvent={(ev) => removeMaskFromEvent(ev, 'CNPJ')}
      rules={!notRequired ? rules : undefined}
    >
      <MaskedInput
        disabled={disabled}
        className="ant-input"
        mask={cnpjMask}
        onChange={onChange}
      />
    </FloatingFormItem>
  ) : (
    <Form.Item
      label={label}
      name={fieldName}
      initialValue={initialValue}
      getValueFromEvent={(ev) => removeMaskFromEvent(ev, 'CNPJ')}
      rules={!notRequired ? rules : undefined}
    >
      <MaskedInput
        disabled={disabled}
        className="ant-input"
        mask={cnpjMask}
        onChange={onChange}
      />
    </Form.Item>
  );
};

CnpjFormField.defaultProps = {};

export default CnpjFormField;
